import script from "./UserPgShosai.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPgShosai.vue?vue&type=script&setup=true&lang=js"

import "./UserPgShosai.vue?vue&type=style&index=0&id=30ca8ef6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30ca8ef6"]])

export default __exports__